var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5499 17.5H7.44989C6.32489 17.5 5.34989 16.675 5.19989 15.55L4.07489 6.1C3.99989 5.8 4.29989 5.5 4.59989 5.5H15.4749C15.7749 5.5 15.9999 5.8 15.9999 6.1L14.7999 15.55C14.5749 16.675 13.6749 17.5 12.5499 17.5Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H7V3.25C7 2.8 7.3 2.5 7.75 2.5H12.25C12.7 2.5 13 2.8 13 3.25V4Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 3.25C14.8 3.25 5.2 3.25 4.75 3.25C3.925 3.25 3.25 3.925 3.25 4.75C3.25 5.575 3.925 6.25 4.75 6.25C5.2 6.25 14.8 6.25 15.25 6.25C16.075 6.25 16.75 5.575 16.75 4.75C16.75 3.925 16.075 3.25 15.25 3.25Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fba50b714f49c0b1e8c1ce4f01b577d2.svg";
export { ForwardRef as ReactComponent };